import React, { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { PlusIcon } from 'lucide-react';
import { useCart } from '../CartContext';
import { useContent } from '../ContentContext';
import { Reveal } from '../components/Reveal';
export function Marketplace() {
  const location = useLocation();
  const {
    addToCart
  } = useCart();
  const {
    businesses
  } = useContent();
  const [activeCategory, setActiveCategory] = useState<string>('Alla');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  const allProducts = businesses.flatMap(b => b.products);
  const activeCategories = ['Alla', ...Array.from(new Set(allProducts.map(p => p.category)))];
  useEffect(() => {
    const param = new URLSearchParams(location.search).get('kategori');
    if (!param) return;
    const match = activeCategories.find(c => c.toLowerCase() === param.toLowerCase());
    setActiveCategory(match ?? 'Alla');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, businesses]);
  const filteredProducts = activeCategory === 'Alla' ? allProducts : allProducts.filter(p => p.category === activeCategory);
  return <div className="min-h-screen bg-gray-50 pt-32 pb-24" data-id="element-496" data-mp="14lzjyb6ncekp">
      <div className="mx-auto max-w-7xl px-6 md:px-10" data-id="element-497" data-mp="14olqq8lpqq1v">
        <Reveal data-id="element-498" data-mp="zo7q3bmfyidv">
          <h1 className="font-display text-4xl font-medium text-gray-900 md:text-5xl" data-id="element-499" data-mp="zopvoyuzu8yg">Vårt utbud</h1>
          <p className="mt-4 text-lg text-gray-600" data-id="element-500" data-mp="1x9vhfi41iaij">Handplockade rätter och menyer från Smålands bästa.</p>
        </Reveal>
        
        <div className="mt-12 flex flex-col gap-10 md:flex-row" data-id="element-501" data-mp="1seg36p24ecll">
          {/* Sticky Sidebar Filter (Uber Eats style) */}
          <aside className="w-full shrink-0 md:w-64" data-id="element-502" data-mp="1imk0t1t040bk">
            <div className="sticky top-28" data-id="element-503" data-mp="1im0ktqmwvm06">
              <h3 className="mb-4 text-xs font-bold uppercase tracking-widest text-gray-400" data-id="element-504" data-mp="2g1ej9lmbviiz">Filtrera</h3>
              <ul className="space-y-1" data-id="element-505" data-mp="2bafwq4aqxo7a">
                {activeCategories.map(cat => <li key={cat} data-id="element-506" data-mp="9dns57vomj03">
                    <button onClick={() => setActiveCategory(cat)} className={`w-full text-left px-4 py-2.5 text-sm font-medium rounded-xl transition-all ${activeCategory === cat ? 'bg-black text-white shadow-md' : 'text-gray-600 hover:bg-gray-200/50 hover:text-gray-900'}`} data-id="element-507" data-mp="9eqldmgh8xj6">
                      {cat}
                    </button>
                  </li>)}
              </ul>
            </div>
          </aside>

          {/* Premium Product Grid */}
          <div className="flex-1" data-id="element-508" data-mp="3cw8udx7zkal6">
            <div className="grid gap-6 sm:grid-cols-2 xl:grid-cols-3" data-id="element-509" data-mp="3hspe8f85k2sg">
              {filteredProducts.map((product, i) => <Reveal key={product.id} delay={Math.min(i * 0.05, 0.3)} data-id="element-510" data-mp="1b42ravl4klil" data-mpi={i}>
                  <div className="group flex h-full flex-col overflow-hidden rounded-3xl bg-white shadow-premium transition-all hover:shadow-premium-hover hover:-translate-y-1" data-id="element-511" data-mp="1g2dx8v8aubvj">
                    <div className="relative h-48 overflow-hidden" data-id="element-512" data-mp="2vktoqi2738b4">
                      <img src={product.image} alt={product.name} className="h-full w-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-513" data-mp="2vmmxc2wdc2lr" />
                      <div className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-gray-900 backdrop-blur-md" data-id="element-514" data-mp="35hygcxet7vzb">
                        {product.category}
                      </div>
                    </div>
                    <div className="flex flex-1 flex-col p-6" data-id="element-515" data-mp="3t8ajzw30v6k3">
                      <Link to={`/partner/${product.businessSlug}`} className="text-[11px] font-bold uppercase tracking-wider text-gray-400 hover:text-black transition-colors" data-id="element-516" data-mp="3t6hp1e1ruarx">
                        {product.businessName}
                      </Link>
                      <h3 className="mt-2 font-display text-xl font-medium text-gray-900" data-id="element-517" data-mp="1tw86r3kzr8ev">{product.name}</h3>
                      <p className="mt-2 text-sm leading-relaxed text-gray-500 line-clamp-2" data-id="element-518" data-mp="kxgge0yazcek">{product.description}</p>
                      
                      <div className="mt-auto pt-6 flex items-center justify-between" data-id="element-519" data-mp="pzpaj0mwwki9">
                        <span className="text-lg font-medium text-gray-900" data-id="element-520" data-mp="uxh03o033uja">{product.price} kr</span>
                        <button onClick={() => addToCart(product)} className="flex h-10 w-10 items-center justify-center rounded-full bg-gray-100 text-gray-900 transition-colors hover:bg-black hover:text-white" aria-label="Lägg till" data-id="element-521" data-mp="yxhpu4smvs5n">
                          <PlusIcon className="h-5 w-5" data-id="element-522" data-mp="fz6lzskekfu0" />
                        </button>
                      </div>
                    </div>
                  </div>
                </Reveal>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}